<div class="pin-kiosk-overlay">
  <roma-mf-time-tracking
    mode="kiosk"
    (onGoToAdmin)="goToAdmin()"
    (onAdminLogout)="confirmAdminLogout()"
  ></roma-mf-time-tracking>

  <div *ngIf="showFullscreenPrompt" class="fullscreen-prompt">
    <div class="fullscreen-prompt__card">
      <p class="fullscreen-prompt__text">
        {{ 'clockHour.pinKioskFullscreenText' | translate }}
      </p>
      <button class="fullscreen-prompt__btn" (click)="enterFullscreen()">
        {{ 'clockHour.pinKioskFullscreenBtn' | translate }}
      </button>
    </div>
  </div>
</div>
